// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Icon = ({className, fontAwesomeType, spin, style, title}) => {
    const getClass = () =>
        classnames(
            {
                fa: true,
                icon: true,
                'fa-spin': spin,
                [`fa-${fontAwesomeType}`]: fontAwesomeType,
            },
            className
        );

    return <i aria-hidden={true} className={getClass()} style={style} title={title} />;
};

Icon.propTypes = {
    className: PropTypes.string,
    fontAwesomeType: PropTypes.string,
    spin: PropTypes.bool,
    style: PropTypes.object,
    title: PropTypes.string,
};

export default Icon;
